// extracted by mini-css-extract-plugin
module.exports = {"teams":"teams-module--teams--25lN_","title":"teams-module--title--fi49z"};